import lodash from 'lodash-es'
import axios from 'axios'
import {
  SET_TRAINEES,
  SET_HABILITATIONS,
  SET_HABILITATIONS_CODES,
} from '../mutation-types'
const habilitations = {
  namespaced: true,
  state: {
    isFiltrSelected: false,
    habilitations: [],
    habilitationsCodes: [],
    pagination: {},
    orderDirection: '-issue_date',
    orderBy: '-issue_date',
    limit: 15,
  },
  mutations: {
    [SET_HABILITATIONS](state, data) {
      console.log('data = ', data)
      state.habilitations = data.data
      state.pagination = data.meta.pagination
    },
    [SET_HABILITATIONS_CODES](state, data) {
      console.log('data = ', data)
      state.habilitationsCodes = data
    },
    [SET_TRAINEES](state, data) {
      console.log('habilitation trainees data = ', data)
      state.trainees = data.data
    },
  },
  actions: {
    getCategoriesList({ rootState }, params = {}) {
      params.companyId = lodash.get(rootState, 'company.id', null)
      params.establishmentId = lodash.get(rootState, 'establishment.id', null)
      return new Promise((resolve, reject) => {
        axios
          .get(
            rootState.apiBaseURL +
              '/habilitations-categories/' +
              rootState.user.id,
            { params }
          )
          .then((response) => {
            if (response) {
              resolve(response?.data?.data ?? [])
            }
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    getQualifsList({ rootState }, params = {}) {
      params.companyId = lodash.get(rootState, 'company.id', null)
      params.establishmentId = lodash.get(rootState, 'establishment.id', null)
      return new Promise((resolve, reject) => {
        axios
          .get(
            rootState.apiBaseURL +
              '/historical-habilitations/' +
              rootState.user.id,
            { params }
          )
          .then((response) => {
            if (response) {
              resolve(response?.data?.data ?? [])
            }
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    uploadHabilitationFile({ commit, state, rootState }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            rootState.apiBaseURL + '/trainee-habilitation-upload-file',
            params
          )
          .then((response) => {
            if (response) {
              resolve(response)
            }
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    updateHabilitation({ commit, state, rootState }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .put(
            rootState.apiBaseURL +
              '/trainee-habilitations/' +
              params.traineeHabilitationId,
            params
          )
          .then((response) => {
            if (response) {
              resolve(response)
            }
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    addNewHabilitation({ commit, state, rootState }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(rootState.apiBaseURL + '/trainee-habilitations', params)
          .then((response) => {
            if (response) {
              resolve(response)
            }
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    searchHabilitations({ commit, state, rootState }, { params = {} }) {
      params.companyId = lodash.get(rootState, 'company.id', null)
      params.establishmentId = lodash.get(rootState, 'establishment.id', null)
      return new Promise((resolve, reject) => {
        axios
          .get(
            rootState.apiBaseURL +
              '/client-trainees-habilitations/' +
              rootState.user.id,
            {
              params,
            }
          )
          .then((response) => {
            let resp = []
            if (lodash.get(response, 'data.data')) {
              let resp = response.data.data
              let meta = response.data.meta
              commit('SET_HABILITATIONS', { data: resp, meta: meta })
            }
            resolve(resp)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    getHabilitations({ commit, state, rootState }, params = {}) {
      params.companyId = lodash.get(rootState, 'company.id', null)
      params.establishmentId = lodash.get(rootState, 'establishment.id', null)
      return axios
        .get(
          rootState.apiBaseURL +
            '/client-trainees-habilitations/' +
            rootState.user.id,
          {
            params,
          }
        )
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            let meta = response.data.meta
            commit('SET_HABILITATIONS', { data: data, meta: meta })
            return data
          } else {
            throw new Error(
              'Impossible de récupérer la liste des habilitations'
            )
          }
        })
    },
    getHabilotationsCodes({ commit, state, rootState }, params = {}) {
      params.companyId = lodash.get(rootState, 'company.id', null)
      params.establishmentId = lodash.get(rootState, 'establishment.id', null)
      return axios
        .get(rootState.apiBaseURL + '/habilitations-codes')
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            commit('SET_HABILITATIONS_CODES', data)
            return data
          } else {
            throw new Error('Impossible de récupérer la liste des codes')
          }
        })
    },
    getTrainees({ commit, rootState }, params = {}) {
      let data = {
        companyId: lodash.get(rootState, 'company.id', null),
        establishmentId: lodash.get(rootState, 'establishment.id', null),
      }
      return axios
        .post(
          rootState.apiBaseURL + '/client-trainees-names/' + rootState.user.id,
          data,
          {
            params,
          }
        )
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            commit('SET_TRAINEES', { data })
            return data
          } else {
            throw new Error('Impossible de récupérer la liste des stagaires')
          }
        })
    },
  },
  getters: {},
}
export default habilitations
